import React, { useEffect, useState } from 'react';
import { FaUser } from "react-icons/fa";
import { IoIosMail } from "react-icons/io";
import { FaPhone } from "react-icons/fa6";
import { GoDotFill } from "react-icons/go";
import { MdAutorenew } from "react-icons/md";
import ErrorMessage from '../common/errorMsg';
import httpService from '../../services/http.service';
import { MdOutlineCancel } from "react-icons/md";
import WarningMessage from '../common/warnMsg';
import SubcriptionModal from './subcriptionModal';
import Loader from '../common/loader';
import CancelSubscription from '../dashboard/cloudDashboard/plans-onboard/cancelSubscription';
import { GrDocumentUpdate } from "react-icons/gr";
import SuccessMessage from '../common/successMsg';
import { useHistory } from 'react-router-dom';
import UpdatePropertyModal from './updatePropertyModal';

const SubcriptionRenew = () => {
    const userId = localStorage.getItem("UserId")
    const history = useHistory()
    const [user, setUser] = useState({
        customerId: "",
        email: "",
        mobileNo: "",
        licenceNo: "",
        startDate: "",
        endDate: "",
        isTrialCompleted: false
    })
    const [updatePropertyData, setUpdatePropertyData] = useState({})
    const [isOpen, setIsOpen] = useState(false)
    const [show, setShow] = useState(false)

    const [updatePropertyModal, setUpdatePropertyModal] = useState(false)
    const [loading, setLoading] = useState(false)
    const [subscriptionLoading, setSubscriptionLoading] = useState(false)

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return date.toLocaleDateString('en-US', options);
    }

    const getUserData = async () => {
        try {
            setLoading(true)
            if(!userId){
                return
            }
            const response = await httpService.get(`/get-user-details?userId=${userId}`)
            setUser(response.data.user)
        } catch (error) {
            ErrorMessage("Something went wrong")
        } finally {
            setLoading(false)
        }
    }



    const onClose = () => {
        setIsOpen(false)
    }

    const getSubscriptionProgress = (startDateStr, endDateStr) => {
        const startDate = new Date(startDateStr);
        const endDate = new Date(endDateStr);
        const today = new Date();

        const totalTime = endDate - startDate;
        const timeUsed = today - startDate;
        const timeLeft = endDate - today;

        const totalDays = Math.ceil(totalTime / (1000 * 60 * 60 * 24));
        const daysLeft = Math.max(0, Math.ceil(timeLeft / (1000 * 60 * 60 * 24)));
        const percentUsed = Math.min(100, Math.max(0, Math.round((timeUsed / totalTime) * 100)));

        return {
            percentUsed,
            daysLeft,
            totalDays
        };
    }

    const checkActiveStatus = () => {
        const subscriptionCheck = getSubscriptionProgress(user.startDate, user.endDate).daysLeft
        if (subscriptionCheck === 0) {
            return false
        }
        else {
            return true
        }
    }

    const subscriptionCancelHandler = async () => {
        try {
            setSubscriptionLoading(true)
            const userId = localStorage.getItem("UserId");

            if (!userId) {
                ErrorMessage("User ID not found in local storage");
                return;
            }
            const { data } = await httpService.CreateUpdate("subscription-cancelled", { userId });

            if (data.ack === "1") {
                SuccessMessage(data.message);
                onClose()
                history.push("/cloudlogin")
                localStorage.clear()
                return
            } else {
                return ErrorMessage("Cancellation failed");
            }
        } catch (error) {
            console.log(error)
            ErrorMessage("Something went wrong");
        } finally {
            setSubscriptionLoading(false)
        }
    };
    useEffect(() => {
        getUserData()
    }, [userId])

    return (
        <>
            {loading ? <Loader /> : <div style={{ display: "flex", backgroundColor: "#f5f7fa", height: 550, width: "100%", borderRadius: 10, overflow: "hidden" }}>
                <div style={{ width: 420, backgroundColor: "#ffffff", height: "100%", padding: 20 }}>
                    <div>
                        <h3 style={{ color: "#4f46e5" }}>User Profile</h3>
                        <p style={{ fontSize: 15, color: "#6b7280" }}>View and manage subscription details</p>
                    </div>

                    <div style={{ marginTop: 20, display: "flex", alignItems: "center", gap: 15, marginBottom: 20 }}>
                        <div style={{ height: 60, width: 60, backgroundColor: "#4f46e5", color: "#fff", borderRadius: "50%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <FaUser size={40} />
                        </div>
                        <div>
                            <p style={{ fontSize: 20, fontWeight: "bold" }}>{user.customerId}</p>
                        </div>
                    </div>
                    <div>
                        <div style={{ display: "flex", marginBottom: 6, alignItems: "center", gap: 5, color: "#374151" }}>
                            <IoIosMail size={20} />
                            <h5>{user.email}</h5>
                        </div>
                        <div style={{ display: "flex", alignItems: "center", gap: 5, color: "#374151" }}>
                            <FaPhone size={20} />
                            <h5>{user.mobileNo}</h5>
                        </div>
                    </div>
                </div>

                <div style={{ flex: 1, backgroundColor: "#ffffff", height: "100%", padding: 20 }}>

                    <div style={{ padding: 15, backgroundColor: "#e0e7ff", borderRadius: 10, display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 15 }}>
                        <p style={{ fontSize: 20, color: "#1e40af" }}>Subscription details</p>
                        {checkActiveStatus() ? <div style={{ backgroundColor: "#22c55e", color: "#fff", padding: "5px 20px", borderRadius: 20, display: "flex", gap: 5, alignItems: "center" }}>
                            <GoDotFill />
                            Active
                        </div> : <div style={{ backgroundColor: "red", color: "#fff", padding: "5px 20px", borderRadius: 20, display: "flex", gap: 5, alignItems: "center" }}>
                            <GoDotFill />
                            Inactive
                        </div>}

                    </div>

                    <div style={{ display: "flex", gap: 10, marginBottom: 10 }}>
                        <div style={{ flex: 1, height: 73, borderRadius: 10, backgroundColor: "#f3f4f6", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                            <p style={{ fontWeight: 500 }}>Account Name</p>
                            <p>{user.customerId}</p>
                        </div>
                        <div style={{ flex: 1, height: 73, borderRadius: 10, backgroundColor: "#f3f4f6", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                            <p style={{ fontWeight: 500 }}>No. of Properties</p>
                            <p>{user.licenceNo}</p>
                        </div>
                    </div>

                    <div style={{ display: "flex", gap: 10, marginBottom: 10 }}>
                        <div style={{ flex: 1, height: 73, borderRadius: 10, backgroundColor: "#fef3c7", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                            <p>Start Date</p>
                            <p>{user?.startDate ? formatDate(user.startDate) : formatDate(new Date())}</p>
                        </div>
                        <div style={{ flex: 1, height: 73, borderRadius: 10, backgroundColor: "#fee2e2", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                            <p>Expiry Date</p>
                            <p>{user?.endDate ? formatDate(user.endDate) : formatDate(new Date())}</p>
                        </div>
                    </div>

                    <div style={{ height: 60, width: "100%", backgroundColor: "#f3f4f6", padding: 10, borderRadius: 10 }}>
                        <div style={{ height: 10, width: "100%", backgroundColor: "#d1d5db", borderRadius: 10, overflow: "hidden", marginBottom: 8 }}>
                            <div style={{ backgroundColor: "#4f46e5", width: `${0 || getSubscriptionProgress(user.startDate, user.endDate).percentUsed}%`, height: "100%" }}></div>
                        </div>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", fontSize: 14 }}>
                            <p style={{ color: "#6b7280" }}>{`${getSubscriptionProgress(user.startDate, user.endDate).percentUsed}% of subscription period used`}</p>
                            <p style={{ color: "#6b7280" }}>{`${getSubscriptionProgress(user.startDate, user.endDate).daysLeft} days remaining`}</p>
                        </div>
                    </div>
                    <div style={{ display: "flex", gap: 5 }}>
                        {user.subscriptionStatus !== "Cancel" && <button onClick={() => setIsOpen(true)} style={{ height: 53, width: "100%", backgroundColor: "red", color: "#fff", marginTop: 15, padding: 10, display: "flex", justifyContent: "center", alignItems: "center", borderRadius: 10, gap: 10, outline: "none", border: "none" }}>
                            <>
                                <MdOutlineCancel size={24} />
                                <h5>{user.subscriptionStatus === "Subscription" ? "Cancel Subscription" : " Cancel Trial"}</h5>
                            </>
                        </button>}
                        {/* {user.isTrialCompleted && user.isActive && (
                            <button
                                onClick={() => setUpdatePropertyModal(true)}
                                style={{
                                    height: 53,
                                    width: "100%",
                                    backgroundColor: "rgb(34, 197, 94)",
                                    color: "#fff",
                                    marginTop: 15,
                                    padding: 10,
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    borderRadius: 10,
                                    gap: 10,
                                    outline: "none",
                                    border: "none",
                                }}
                            >
                                <GrDocumentUpdate size={24} />
                                <h5>Update Property</h5>
                            </button>
                        )} */}

                        <button onClick={() => checkActiveStatus() === false && setShow(true)} disabled={checkActiveStatus() || loading} style={{ height: 53, width: "100%", backgroundColor: checkActiveStatus() || loading ? "rgb(197, 195, 225)" : "#4f46e5", color: "#fff", marginTop: 15, padding: 10, display: "flex", justifyContent: "center", alignItems: "center", borderRadius: 10, gap: 10, outline: "none", border: "none" }}>
                            {loading ? <h5>Loading...</h5> : <>
                                <MdAutorenew size={24} />
                                <h5>Renew Subscription Now</h5>
                            </>}
                        </button>
                    </div>
                </div>
                <SubcriptionModal data={user} show={show} setShow={setShow} api={"payment-intiate"} />
                {/* <UpdatePropertyModal isOpen={updatePropertyModal} onCancel={setUpdatePropertyModal} initalQuantity={user.licenceNo} /> */}
                <CancelSubscription isOpen={isOpen} onCancel={onClose} onConfirm={subscriptionCancelHandler} loading={subscriptionLoading} subscriptionStatus={user.subscriptionStatus} />
            </div>}
        </>

    );
};

export default SubcriptionRenew;
